// 寄售封禁
export const SALE_COLUMNS = [
  {
    title: "游戏ID",
    key: "game_id",
    align: "center",
  },
  {
    title: "游戏名称",
    key: "game_name",
    align: "center",
  },
  {
    title: "角色ID",
    key: "role_id",
    align: "center",
  },
  {
    title: "封禁类型",
    align: "center",
    render: (h, params) => {
      const str = `${params.row.ban_role === 1 ? "角色" : ""} ${
        params.row.ban_coin === 1 ? "货币" : ""
      } ${params.row.ban_equip === 1 ? "装备" : ""}`;
      return h("div", str);
    },
  },
  {
    title: "状态",
    align: "center",
    render: (h, params) => {
      const str =
        params.row.status === 1
          ? "封禁中"
          : params.row.status === 0
          ? "已解封"
          : "未知";
      return h("div", str);
    },
  },
  {
    title: "封禁时间",
    key: "ban_time",
    align: "center",
  },
  {
    title: "解封时间",
    key: "unban_time",
    align: "center",
  },
  {
    title: "操作",
    slot: "saleAction",
    align: "center",
  },
];
// 盒子号寄售封禁
export const ACCOUNT_COLUMNS = [
  {
    title: "用户id",
    key: "uid",
    align: "center",
  },
  {
    title: "状态",
    align: "center",
    render: (h, params) => {
      const str =
        params.row.status === 1
          ? "已封禁"
          : params.row.status === 0
          ? "已解封"
          : "未知";
      return h("div", str);
    },
  },
  {
    title: "操作",
    slot: "accountAction",
    align: "center",
  },
];
